import styled from '@emotion/styled';

export const AuditValueName = styled('td', { label: 'AuditValueName' })`
    text-transform: capitalize;
`;
